document.addEventListener('DOMContentLoaded', function () {
    const tooltip = document.getElementById('tooltip');
    const tooltipOverlay = document.getElementById('tooltip-overlay');
    const title = document.getElementById('tooltip-title');
    const text = document.getElementById('tooltip-text');
    const closeBtn = document.getElementById('js-close-tooltip');
    const trigger = document.querySelectorAll('.tooltip-trigger');

    if (tooltip) {
        trigger.forEach((trigger) => {
            trigger.addEventListener('click', () => {
                tooltip.classList.add('open');
                tooltipOverlay.classList.add('open');
                title.textContent = trigger.getAttribute('data-title');
                text.textContent = trigger.getAttribute('data-text');
            })
        })

        closeBtn.addEventListener('click', function () {
            tooltip.classList.remove('open');
            tooltipOverlay.classList.remove('open');
        });
    }
});
